<script>
import PreviewElement from "./PreviewElement";
import SpacerElement from "../../components/pagesbuilder/elements/SpacerElement";

export default {
    name: "PreviewSpacerElement",
    mixins: [PreviewElement, SpacerElement],
}
</script>